import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const selectedOptionAtom = atomWithStorage<string>(
  'market-segment-selected-option',
  'CONDITION',
  undefined,
  { getOnInit: true },
);
export const selectedSegmentAtom = atomWithStorage<string>(
  'market-segment-selected-segment',
  'NEW',
  undefined,
  { getOnInit: true },
);

export const starredSegmentListAtom = atomWithStorage<string[]>(
  'starred-segment-list',
  [],
  undefined,
  { getOnInit: true },
);
export const segmentSearchOptionAtom = atom<boolean>(false);
